export { default } from './ThemeProvider';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/ThemeProvider/index.js
// module id = 910
// module chunks = 2